const useLimitedFeatures = () => window.REACT_APP_LIMITED_FEATURES === 'true';

export default useLimitedFeatures;
